module.exports = __webpack_public_path__ + "img/DE00956.7a91c139.png";